<template>
  <div>
    <v-container>
      <div class="pb-4">
        <div class="pb-2 text-xs-left" :class="[$style.headingText]">
          {{ lang.title + lang.required }}
        </div>
        <v-text-field
          outline
          single-line
          :counter="50"
          :label="lang.title + lang.required"
          :value="title"
          @input="updateTitle"
          required
        ></v-text-field>
      </div>

      <div class="pb-4">
        <connect-vc-share-comic-thumbnail
          :lang="lang"
        ></connect-vc-share-comic-thumbnail>
      </div>

      <div class="pb-4">
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <div class="pb-2 text-xs-left" :class="[$style.headingText]">
          {{ lang.description + lang.required }}
        </div>
        <v-textarea
          :class="$style.description"
          :label="lang.description + lang.required"
          :counter="200"
          no-resize
          :value="description"
          @input="updateDescription"
          required
          outline
          single-line
        ></v-textarea>
      </div>

      <div class="pb-4" v-show="!isSecureView">
        <connect-vc-share-social-media-image
          :lang="lang"
        ></connect-vc-share-social-media-image>
      </div>

      <div v-if="pageProgressionDirection !== 'vertical'">
        <div>
          <connect-vc-share-comic-size
            :lang="lang"
            :is-panel="isPanel"
          ></connect-vc-share-comic-size>
        </div>

        <!-- 縦横比 -->
        <v-layout v-if="!isPanel && !isUploadIceContents" column class="my-4">
          <div class="pb-2 text-xs-left" :class="[$style.headingText]">
            {{ lang.contents_aspect_ratio_title }}
          </div>
          <v-radio-group
            :value="aspectRatioType"
            @change="updateAspectRatioType"
          >
            <v-radio
              :label="lang.contents_aspect_ratio_book_size"
              value="book_size_ratio"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.contents_aspect_ratio_book_size_description }}
            </div>

            <v-radio
              :label="lang.contents_aspect_ratio_image_size"
              value="image_ratio"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.contents_aspect_ratio_image_size_description }}
            </div>
          </v-radio-group>
        </v-layout>

        <!-- 表紙の固さ -->
        <v-layout v-if="!isPanel" column class="my-4">
          <div class="pb-2 text-xs-left" :class="[$style.headingText]">
            {{ lang.cover_hardness_title }}
          </div>
          <v-radio-group :value="coverHardness" @change="updateCoverHardness">
            <v-radio :label="lang.cover_hardness_soft" value="soft"></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.cover_hardness_soft_description }}
            </div>

            <v-radio :label="lang.cover_hardness_hard" value="hard"></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.cover_hardness_hard_description }}
            </div>
          </v-radio-group>
        </v-layout>

        <!-- 紙質・加工（表紙／パネル） -->
        <v-layout v-if="!isPanel" column class="my-4">
          <div class="pb-2 text-xs-left" :class="[$style.headingText]">
            {{ lang.cover_process_title }}
          </div>
          <v-radio-group :value="coverProcess" @change="updateCoverProcess">
            <v-radio
              :label="lang.cover_process_coated_nonprocessed"
              value="coated_nonprocessed"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.cover_process_coated_nonprocessed_description }}
            </div>

            <v-radio
              :label="lang.cover_process_coated_clear_pp"
              value="coated_clear_pp"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.cover_process_coated_clear_pp_description }}
            </div>

            <v-radio
              :label="lang.cover_process_canvas_nonprocessed"
              value="canvas_nonprocessed"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.cover_process_canvas_nonprocessed_description }}
            </div>
          </v-radio-group>
        </v-layout>
        <v-layout v-else column class="my-4">
          <div class="pb-2 text-xs-left" :class="[$style.headingText]">
            {{ lang.process_title }}
          </div>
          <v-radio-group :value="coverProcess" @change="updateCoverProcess">
            <v-radio
              :label="lang.cover_process_canvas_nonprocessed"
              value="canvas_nonprocessed"
            ></v-radio>
            <div :class="$style.radioCaption">
              {{ lang.cover_process_canvas_nonprocessed_description }}
            </div>

            <v-radio
              :label="lang.cover_process_coated_nonprocessed"
              value="coated_nonprocessed"
            ></v-radio>
            <div :class="$style.radioCaption">
              {{ lang.cover_process_coated_nonprocessed_description }}
            </div>

            <v-radio
              :label="lang.cover_process_coated_clear_pp"
              value="coated_clear_pp"
            ></v-radio>
            <div :class="$style.radioCaption">
              {{ lang.cover_process_coated_clear_pp_description }}
            </div>
          </v-radio-group>
        </v-layout>

        <!-- 本文の紙質 -->
        <v-layout v-if="!isPanel" column class="my-4">
          <div class="pb-2 text-xs-left" :class="[$style.headingText]">
            {{ lang.body_paper_type_title }}
          </div>
          <v-radio-group :value="bodyPaperType" @change="updateBodyPaperType">
            <v-radio
              :label="lang.body_paper_type_book_paper"
              value="book_paper"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.body_paper_type_book_paper_description }}
            </div>

            <v-radio
              :label="lang.body_paper_type_coated"
              value="coated"
            ></v-radio>
            <div :class="[$style.radioCaption, radioButtonDescriptionStyle]">
              {{ lang.body_paper_type_coated_description }}
            </div>
          </v-radio-group>
        </v-layout>

        <!-- 背表紙 -->
        <v-layout v-if="!isPanel" class="my-4">
          <v-flex>
            <connect-vc-share-comic-spine
              :lang="lang"
            ></connect-vc-share-comic-spine>
          </v-flex>
        </v-layout>

        <!-- 初期表示チェックボックス -->
        <v-checkbox
          v-if="!isPanel"
          class="mt-0"
          v-model="currentIsDefaultHybrid3d"
          :label="lang.default_hybrid3d"
          :true-value="true"
          :false-value="false"
          @change="updateIsDefaultHybrid3d"
        ></v-checkbox>
      </div>

      <v-responsive class="text-xs-right" max-width="100%">
        <v-btn
          v-if="!isUploadIceContents"
          color="secondary"
          :class="[$style.btnTextStyle]"
          :loading="isPreviewProcessing"
          :disabled="isPreviewProcessing || !isUpdatedImage"
          @click="onClickCreatePreview"
        >
          {{ lang.preview_create }}
        </v-btn>

        <v-btn
          v-if="!isUploadIceContents"
          color="secondary"
          :class="['ml-0', $style.btnTextStyle]"
          :loading="isLoadingShowPreview"
          :disabled="isPreviewProcessing || !previewUrl || isLoadingShowPreview"
          @click="onClickViewPreview"
        >
          {{ lang.preview_view }}
        </v-btn>

        <v-btn
          v-else
          color="secondary"
          :class="['ml-0', $style.btnTextStyle]"
          :loading="isLoadingShowPreview"
          :disabled="isLoadingShowPreview"
          @click="onClickViewPreview"
        >
          {{ lang.preview_view }}
        </v-btn>

        <div v-if="isPreviewProcessing">
          <v-progress-linear v-model="previewProgressRate" />
        </div>
      </v-responsive>
    </v-container>
  </div>
</template>

<script>
import log from "loglevel";
import ice from "../../../lib/ice";

export default {
  name: "vc-share-comic-info-form",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => ({
        title: "タイトル",
        description: "せつめい",
        required: "（必須）",
        preview_create: "プレビューを作成する",
        preview_view: "プレビューを表示する"
      })
    },

    // state
    pageProgressionDirection: {
      type: String,
      default: "rtl"
    },
    isUploadIceContents: {
      type: Boolean,
      default: false
    },
    isUpdatedImage: {
      type: Boolean,
      default: false
    },
    isUpdatedHybrid3dSettings: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => {
        return [{ src: "" }];
      }
    },
    previewUrl: {
      type: String,
      default: null
    },
    aspectRatioType: {
      type: String,
      default: "book_size_ratio"
    },
    coverHardness: {
      type: String,
      default: ""
    },
    coverProcess: {
      type: String,
      default: ""
    },
    bodyPaperType: {
      type: String,
      default: ""
    },
    isDefaultHybrid3d: {
      type: Boolean,
      default: true
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    isSecureView: {
      type: Boolean,
      default: false
    },

    // getters
    spineImageHeightMM: {
      type: Number,
      default: 0
    },
    spineImageWidthMM: {
      type: Number,
      default: 0
    },
    spineImageUrl: {
      type: String,
      default: ""
    },

    // actions
    preview: {
      type: Function,
      default: () => {}
    },
    putDraft: {
      type: Function,
      default: async () => {}
    },
    previewProgress: {
      type: Function,
      default: () => {}
    },
    updateHybrid3dSettings: {
      type: Function,
      default: () => {}
    },

    // mutations
    updateCoverHardness: {
      type: Function,
      default: () => {}
    },
    updateCoverProcess: {
      type: Function,
      default: () => {}
    },
    updateBodyPaperType: {
      type: Function,
      default: () => {}
    },
    updateIsDefaultHybrid3d: {
      type: Function,
      default: () => {}
    },
    updateAspectRatioType: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    previewProgressRate: 0,
    isPreviewProcessing: false,
    isLoadingShowPreview: false,
    currentIsDefaultHybrid3d: true,
    radioButtonDescriptionStyle: "body-2 grey--text text--darken-1"
  }),
  methods: {
    updateTitle(value) {
      this.$emit("changeTitle", value);
    },

    updateDescription(value) {
      this.$emit("changeDescription", value);
    },

    onClick(event) {
      ice.onClickLink(event);
    },

    async onClickCreatePreview() {
      const IMAGE_UPLOAD_TIME = 700;
      const IMAGES_UPLOAD_COUNT = this.images.length;

      const vue = this;

      vue.isPreviewProcessing = true;
      vue.previewProgressRate = 0;

      // 読む方向を記録するため、下書き保存を行ってからプレビュー生成を行う
      // 下書き保存でエラーがでた場合は以降の処理をキャンセル
      try {
        await vue.putDraft();
      } catch (error) {
        vue.isPreviewProcessing = false;
        vue.previewProgressRate = 0;
        return;
      }

      /**
       * プレビュー処理処理
       */
      try {
        vue.preview();
      } catch (error) {
        vue.isPreviewProcessing = false;
        vue.previewProgressRate = 0;

        log.error("preview:", error);
      }

      /**
       * 進捗表示処理プログレスバーの表示
       */
      const doProgress = () => {
        vue.previewProgress().then(params => {
          if (!params) {
            return false;
          }
          const status = params.status;
          const responseViewerUrl = params.viewerUrl;

          switch (status) {
            case "complete":
              vue.previewProgressRate = 100;
              vue.isPreviewProcessing = false;

              if (ice.isIce()) {
                ice.openUrl(responseViewerUrl, true);
              } else {
                window.open(responseViewerUrl);
              }
              break;
            case "error":
              this.isPreviewProcessing = false;
              break;
            case "in_progress":
            default:
              vue.previewProgressRate += Math.floor(100 / IMAGES_UPLOAD_COUNT);

              // 99パーセント超えていたら 99 で固定
              vue.previewProgressRate =
                vue.previewProgressRate > 99 ? 99 : vue.previewProgressRate;

              // プログレスバーの更新処理
              setTimeout(doProgress, IMAGE_UPLOAD_TIME);
              break;
          }
        });
      };

      // 進捗表示処理開始
      setTimeout(doProgress, IMAGE_UPLOAD_TIME);
    },

    onClickViewPreview() {
      this.isLoadingShowPreview = true;

      if (!this.isUpdatedHybrid3dSettings && this.previewUrl) {
        if (ice.isIce()) {
          ice.openUrl(this.previewUrl, true);
        } else {
          window.open(this.previewUrl);
        }
        this.isLoadingShowPreview = false;
      } else {
        this.updateHybrid3dSettings().then(res => {
          const responseViewerUrl = res.viewerUrl;
          if (!responseViewerUrl) {
            this.isLoadingShowPreview = false;
            return false;
          }

          if (ice.isIce()) {
            ice.openUrl(responseViewerUrl, true);
          } else {
            window.open(responseViewerUrl);
          }
          this.isLoadingShowPreview = false;
        });
      }
    }
  },
  watch: {
    isDefaultHybrid3d() {
      this.currentIsDefaultHybrid3d = this.isDefaultHybrid3d;
    }
  }
};
</script>

<style module>
.description textarea {
  height: 200px;
}

.radioCaption {
  margin-left: 34px;
  margin-bottom: 16px;
}

.headingText {
  font-weight: bold;
  font-size: 16px;
}
</style>
